module.exports = __webpack_public_path__ + "img/register-v2.2ef80c0a.svg";